import { isObject } from '@iconik-io/core/src/is_object';
import type { PlaylistItem } from '@iconik-io/unified-player-core';
import { createAppPlayerContext } from '@iconik-io/unified-player-ui-react';

export type AppPlaylistItemMeta = {
  assetId: string;
  versionId: string | undefined;
  // Image proxy URL usable as a fallback when the PDF original file URL is
  // missing (deleted, or the share disallows downloads).
  // TODO(FE-7071): Remove once PDFs are rendered from proxies only and
  // originals are not loaded for viewing.
  pdfFallbackImageUrl?: string;
};

export type AppPlaylistItem = PlaylistItem<AppPlaylistItemMeta>;

/**
 * The player types a playlist item's meta as unknown when it is not built from
 * the app's own item type, as the DRM callback receives it.
 */
export const isAppPlaylistItemMeta = (
  meta: unknown,
): meta is AppPlaylistItemMeta =>
  isObject(meta) &&
  typeof meta.assetId === 'string' &&
  (meta.versionId === undefined || typeof meta.versionId === 'string') &&
  (meta.pdfFallbackImageUrl === undefined ||
    typeof meta.pdfFallbackImageUrl === 'string');

const appPlayerContext = createAppPlayerContext<AppPlaylistItemMeta>();

export const useAppPlayerContext = appPlayerContext.usePlayerContext;

export const AppPlayerContextProvider = appPlayerContext.PlayerContextProvider;
